/* eslint-disable react/no-array-index-key */
import { Spacing4 } from 'autogen/design-tokens/tokens';
import type { CheckoutBasketDiscountInfoViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import { Typography } from 'components/generic/typography';
import styled from 'styled-components';
import LoginActions from './LoginActions';

const StyledFlexRow = styled(Layout.Flex.Row)`
    && {
        flex-wrap: wrap;
    }
`;

export default function PotentialDiscounts({
    model
}: {
    model: CheckoutBasketDiscountInfoViewModel['potentialDiscounts'];
}) {
    return (
        <>
            {model.map((potentialDiscount, index) => (
                <StyledFlexRow gap={Spacing4} alignItems="center" key={index}>
                    <Typography.Body as="span" size="S" strong>
                        {potentialDiscount.text} -&nbsp;
                    </Typography.Body>

                    {potentialDiscount.remainingText && (
                        <Typography.Body as="span" size="S" strong>
                            {potentialDiscount.remainingText}
                        </Typography.Body>
                    )}

                    {potentialDiscount.isLoginNeeded && <LoginActions />}
                </StyledFlexRow>
            ))}
        </>
    );
}
